export const isTabletOrBelow = (): boolean => {
  const w =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  return w < 950;
};
